import { render, staticRenderFns } from "./MarketingFooter.vue?vue&type=template&id=00b54062&"
import script from "./MarketingFooter.vue?vue&type=script&lang=js&"
export * from "./MarketingFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports